<div *ngIf="shouldShowNotification"
     class="version-notification mat-elevation-z4">
  <div class="notification-content">
    <div class="notification-body">
      <h3 class="notification-title">We've updated Agenda Master behind the scenes.</h3>
      <p class="notification-message">
        Time for a quick refresh to enjoy the latest improvements. Don't worry, your content and settings won't change.
      </p>
      <div class="notification-actions">
        <button mat-raised-button color="primary" (click)="onRefresh()">
          Refresh Now
        </button>
        <button mat-stroked-button color="basic" (click)="onClose()" class="ml-2">
          Remind Me Later
        </button>
      </div>
    </div>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
